import React from 'react';

import * as S from './RoomSelection.styles';

import RoomFlavor from './RoomFlavor';

// TYPES
import {RoomFlavorProps} from './Room';
import {RplType, StaticRoomInfo, DetailsStateShape} from '../../redux/types';

// SELECTORS
import {
  checkinSelectorFn,
  checkoutSelectorFn,
  // roomStringSelectorFn,
} from '../../../common/redux/selectors';

import {
  selectedHotelStatic as selectedHotelStaticSelectorFn,
  cityId as cityIdSelectorFn,
  hotelArea as hotelAreaSelectorFn,
  hotelNameSelectedHotelStaticSelector as hnSelectedHotelStaticSelector,
  hotelIdSelector,
  offerCodeSelector,
} from '../../selectors';

// UTILS
import dateformat from 'dateformat';
import {replaceLastHyphenWithUnderScore} from '../../../../utils/common-utils';
import useNavigateToReviewPage from '../../../../hooks/useNavigateToReviewPage';
// HOOKS
import {useSelector} from 'react-redux';

export type RoomFlavorsPropTypes = {
  roomFlavorsList: RoomFlavorProps[];
  roomTypeName: string;
  noInclusionsAndSplInstructionsForAnyRoom: boolean;
};

export type QueryParamsForReviewUrlPropsTypes = {
  hc: DetailsStateShape['vhid'];
  vert: 'hotels';
  strQry: string;
  v: string;
  rtc: string;
  rpc: string;
  fwdParams: string; // stringified forward params
  newui: 'True';
  pah: 'new' | null;
  code: string; // promo code 'pc'
  pay_mode: RplType['pm'];
  gds: 'true';
  rtn: StaticRoomInfo['type_name'];
  gseg: RplType['gseg'];
  cot: RplType['cot'];
  hmd: RplType['hmd'];
  gsv: RplType['gsv'];
  hOfferCode: string | number;
  hotelName: string;
  hotelArea: string;
  cityCode: string;
  gtv: string;
  rmPrice: number;
};

const RoomFlavors: React.FC<RoomFlavorsPropTypes> = ({
  roomFlavorsList,
  roomTypeName,
  noInclusionsAndSplInstructionsForAnyRoom,
}) => {
  const selectedHotelStatic = useSelector(selectedHotelStaticSelectorFn);
  const cityId = useSelector(cityIdSelectorFn);
  const checkinJSDate = useSelector(checkinSelectorFn).date;
  const checkoutJSDate = useSelector(checkoutSelectorFn).date;
  // const roomString = useSelector(roomStringSelectorFn);
  const hotelName = useSelector(hnSelectedHotelStaticSelector);
  const checkinYYYYMMDD = dateformat(checkinJSDate, 'yyyymmdd');
  const checkoutYYYYMMDD = dateformat(checkoutJSDate, 'yyyymmdd');
  const hotelArea = useSelector(hotelAreaSelectorFn);
  const [navigator] = useNavigateToReviewPage();

  const offerCodeFromSrp = useSelector(offerCodeSelector);

  const navigateToReviewPageCaller = (urlParams, descBlockInput) => {
    navigator(urlParams, descBlockInput);
  };

  /**
   * CANCELLATION POLICY URL CALCULATION
   */
  const hotelCode = useSelector(hotelIdSelector);
  const cityCode = cityId;

  return (
    <S.RoomRatePriceOuterWrap>
      {roomFlavorsList.map((roomFlavor, index) => {
        const {
          forwardParams,
          roomPriceCode,
          offercode,
          vendor,
          paymode,
          roomTypeCode,
          paxString,
          gseg,
          cot,
          hmd,
          gsv,
          pc, // promo code
          gtv,
          showPrice
        } = roomFlavor;

        const cancellationPolicyProps = {
          forwardParams,
          roomPriceCode,
          offercode,
          vendor,
          paymode,
          roomTypeCode,
          checkinYYYYMMDD,
          checkoutYYYYMMDD,
          cityCode,
          hotelCode,
          paxString,
          gseg,
          gsv,
          cot
        };

        const queryParamsForReviewUrlProps: QueryParamsForReviewUrlPropsTypes = {
          hc: hotelCode,
          vert: 'hotels',
          strQry: `hotels-${cityCode}-${checkinYYYYMMDD}-${checkoutYYYYMMDD}-${paxString}`,
          v: vendor,
          rtc: roomTypeCode,
          rpc: roomPriceCode,
          fwdParams: JSON.stringify(forwardParams),
          newui: 'True',
          pah: paymode === 2 || paymode === 4 ? 'new' : null,
          code: offerCodeFromSrp || pc,
          pay_mode: paymode,
          gds: 'true',
          rtn: roomTypeName,
          gseg,
          cot,
          hmd,
          gsv,
          hOfferCode: offercode,
          hotelArea,
          hotelName,
          cityCode,
          gtv,
          rmPrice: showPrice
        };

        const queryParamsForReviewUrlPropsBase64 = {
          data: Buffer.from(JSON.stringify(queryParamsForReviewUrlProps)).toString('base64'),
        };

        const descBlockInput = {
          ...queryParamsForReviewUrlProps,
          paxString,
        };

        return (
          <RoomFlavor
            key={roomFlavor.uid ? roomFlavor.uid : index}
            roomFlavor={{...roomFlavor, index, lastIndex: roomFlavorsList.length - 1}}
            cancellationPolicyProps={cancellationPolicyProps}
            queryParamsForReviewUrlProps={queryParamsForReviewUrlProps}
            noInclusionsAndSplInstructionsForAnyRoom={noInclusionsAndSplInstructionsForAnyRoom}
            selectRoomClickHandler={() =>
              navigateToReviewPageCaller(queryParamsForReviewUrlPropsBase64, descBlockInput)
            }
          />
        );
      })}
    </S.RoomRatePriceOuterWrap>
  );
};

export default RoomFlavors;
